/* eslint react/prop-types: off */
import { Col, FormInput, FormInputCheckbox, FormInputText, Icon, Tip, FormInputSelect } from 'camino-react'
import _, { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import CreatableSelect from 'react-select/lib/Creatable'

import { cloudhelpGet } from 'Utilities/CloudHelp'

import ClientContactSelectField from './ClientContactSelectField'

const ClientContactForm = ({
  clientOptions,
  setFieldErrorClasses,
  currentUser,
  clientNoticesContent,
  clientProperties,
  setFormState,
  addClientContactListToClient,
  contactNumber,
  disabledContactNotifications,
  securityIssue
}) => {
  const [showSecondaryContactField, setShowSecondaryContactField] = useState(false)
  const [clientContactsLoading, setClientContactsLoading] = useState(false)
  const [primaryContactHasNoNumber, verifyContactNumber] = useState(false)
  const [secondaryContactEmail, setContactEmail] = useState(null)

  const handleClientSelectChange = (selectedOption = {}) => {
    const newClientId = selectedOption.value

    cloudhelpGet(`/api/clients/${newClientId}/users`)
      .then((response) => {
        const { data } = response
        const users = _.map(data, user => ({
          value: user.id,
          label: user.name,
          email: user.email,
          contactNumber: user.contact_number
        }))

        setClientContactsLoading(false)
        addClientContactListToClient(newClientId, users)
      })
  }

  const handleClientContactSelectChange = (selectedOption = {}) => {
    const { value, email, contactNumber } = selectedOption

    clientProperties.setFieldValue('client_contact_id', value)
    clientProperties.setFieldValue('primary_contact_email', email)
    setFormState('client_contact_id', value)
    setFormState('primary_contact_email', email)
    verifyContactNumber(isEmpty(contactNumber))
  }

  const toggleSecondaryContactField = (event) => {
    if (showSecondaryContactField) {
      clientProperties.setFieldValue('secondary_contact_email', '')
      setContactEmail(null)
    }
    event.preventDefault()
    setShowSecondaryContactField(prevshowSecondaryContactField => !prevshowSecondaryContactField)
  }

  const clientUsers = _.find(clientOptions, { value: clientProperties.client_id })
  const clientsUsersOptions = _.isNil(clientUsers) ? clientUsers : _.sortBy(clientUsers.users, 'label')
  const clientsUsersEmailsOptions = _.isNil(clientsUsersOptions) ? [] : _.map(clientsUsersOptions, user => ({ value: user.email, label: user.email }))
  const selectedClientOption = _.find(clientOptions, { value: clientProperties.client_id })
  const selectedClientsUserOption = _.find(clientsUsersOptions, { value: clientProperties.client_contact_id })
  if (!currentUser.isCalligoEmployee && _.isNil(clientUsers)) {
    const currentUserClient = { label: currentUser.client.short_name, value: currentUser.client.id }
    handleClientSelectChange(currentUserClient)
    clientProperties.setFieldValue('client_id', currentUserClient.value)
    setFormState('client_id', currentUserClient.value)
    setFormState('client_name', currentUserClient.label)
  }

  return (
    <div className="mt-4">
      {currentUser.isCalligoEmployee && (
        <div className="mb-4">
          <label id="clientIdLabel" htmlFor="client_id">
            Client
            <FormInputSelect
              id="client_id"
              isClearable
              options={clientOptions}
              isLoading={_.isEmpty(clientOptions)}
              isDisabled={_.isEmpty(clientOptions)}
              value={selectedClientOption}
              onValue={(option) => {
                handleClientSelectChange(option)
                clientProperties.setFieldValue('client_id', option.value)
                setFormState('client_id', option.value)
                setFormState('client_name', option.label)
              }}
              className={`${setFieldErrorClasses('client_id')} my-0`}
            />
          </label>

          {selectedClientOption?.keyClient && (
            <div className="flex items-center text-lg mt-1">
              <span className="text-xl mr-2 font-semibold"> Key Client</span>
              <Icon style={{ fontWeight: 900 }} type="key" />
            </div>
          )}

          {selectedClientOption?.clientStatus === 'historic' && (
            <div className="text-red-500 text-xl font-medium">
              Client status is Historic
            </div>
          )}

          {selectedClientOption?.clientStatus === 'pending_offboarding' && (
            <div className="text-yellow-600 text-xl font-medium">
              Client status is Pending Offboarding
            </div>
          )}
        </div>
      )}

      {_.some(clientNoticesContent) && currentUser.calligo_employee && (
        <ul className="detail-list">
          <li className="detail-list__info-box">
            <p className="detail-list__title">Notices</p>
            {_.some(clientNoticesContent) &&
              _.map(clientNoticesContent, notice => (
                <div className="detail-list__item">{notice}</div>
              ))}
          </li>
        </ul>
      )}

      <label htmlFor="ticket_client_contact_id">
        Client contact
        <ClientContactSelectField {...{
          loadingClients: _.isEmpty(clientsUsersOptions),
          clientContactsLoading,
          clientsUsersOptions,
          selectedClientsUserOption,
          setFieldErrorClasses,
          setFormState,
          canCreateUsers: (currentUser.isCalligoEmployee || _.get(currentUser, 'client.id') === 1179),
          handleClientContactSelectChange,
          clientProperties
        }}
        />
      </label>

      {primaryContactHasNoNumber && currentUser.calligo_employee && (
        <div className="row no-gutters" style={{ alignItems: 'center', marginTop: '20px' }}>
          <Col>
            <FormInput label="Contact number">
              <FormInputText
                errors={(isEmpty(contactNumber)) ? ['Selected client contact has no contact number. Please input ticket contact number.'] : []}
                value={contactNumber}
                onValue={value => setFormState('contact_number', value)}
              />
            </FormInput>
          </Col>
        </div>
      )}

      {currentUser.calligo_employee && (
        <div className="mt-6 flex items-center">
          <FormInputCheckbox
            value={disabledContactNotifications}
            onValue={value => setFormState('disabled_contact_notifications', value)}
          >
            <span className="mr-2">
              Disable client notifications for this ticket
            </span>
          </FormInputCheckbox>

          <Tip content="Select this checkbox if you don't want to send any email to the customer contact" />
        </div>
      )}

      <div className="mt-6 flex items-center">
        <FormInputCheckbox
          value={securityIssue}
          onValue={value => setFormState('security_issue', value)}
        >
          <span className="mr-2">
            Security Issue
          </span>
        </FormInputCheckbox>

        <Tip content="Select this box if the problem could be a potential security risk." />
      </div>

      <div className="row no-gutters" style={{ alignItems: 'center', marginTop: '20px' }}>
        {showSecondaryContactField && (
          <Col width={19}>
            <FormInput label="Secondary Contact Email">
              <CreatableSelect
                disabled={_.isEmpty(clientOptions)}
                options={clientsUsersEmailsOptions}
                value={secondaryContactEmail}
                onChange={(value) => { clientProperties.setFieldValue('secondary_contact_email', value.value); setContactEmail(value) }}
              />
            </FormInput>
          </Col>
        )}

        <Col width={showSecondaryContactField ? 5 : 24}>
          <button onClick={event => toggleSecondaryContactField(event)} type="button" className="button button--link" style={showSecondaryContactField ? {} : { padding: 'initial' }}>
            <span style={{ border: '0' }} className={`lnr ${showSecondaryContactField ? 'lnr-minus' : 'lnr-plus'} lnr-inline lnr-black lnr-small`} />
            {' '}
            {showSecondaryContactField ? 'Remove' : 'Add Secondary Contact'}
          </button>
        </Col>
      </div>
    </div>
  )
}

export default ClientContactForm
